import { Icon, Link } from '@nimbus-ds/components';
import { ExternalLinkIcon } from '@nimbus-ds/icons';
import { HelpLink } from '@nimbus-ds/patterns';
import { HELP_LINKS_TO_EDIT_ORDERS } from 'commons/constants';
import { useTranslationLanguage } from 'commons/hooks';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';

export function EditOrderHelpLink() {
  const t = useTranslationOrders();
  const language = useTranslationLanguage();

  return (
    <HelpLink>
      <Link
        as="a"
        href={HELP_LINKS_TO_EDIT_ORDERS[language]}
        target="_blank"
        appearance="primary"
        textDecoration="none"
      >
        {t('editOrders.helpLink.text')}
        <Icon source={<ExternalLinkIcon />} color="currentColor" />
      </Link>
    </HelpLink>
  );
}
